// src/utils/print/printRoot.js
const sameOriginCss = () =>
  [...document.styleSheets]
    .map((sheet) => {
      try {
        return [...sheet.cssRules].map((r) => r.cssText).join("\n");
      } catch (e) {
        return ""; // cross-origin sheet (CDN) — deliberately left out of the print
      }
    })
    .join("\n");

export const printElement = (
  element,
  { title = document.title, orientation = "landscape", paper = "A3", timeoutMs = 120000, onClone } = {}
) =>
  new Promise((resolve, reject) => {
    const iframe = document.createElement("iframe");
    iframe.setAttribute("data-print-root", "");
    iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
    let done = false;
    let printed = false;
    const finish = (error) => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      iframe.remove();
      error ? reject(error) : resolve();
    };
    // Some WebKit builds never fire afterprint: a print() that already returned is a success, not a failure.
    const timer = setTimeout(() => finish(printed ? undefined : new Error("print timeout")), timeoutMs);

    iframe.addEventListener("load", async () => {
      try {
        const doc = iframe.contentDocument;
        doc.head.innerHTML = `<style>${sameOriginCss()}\n@page { size: ${paper} ${orientation}; margin: 10mm }\nbody { margin: 0 }</style>`;
        doc.title = title;
        const clone = element.cloneNode(true);
        doc.body.appendChild(clone);
        onClone?.(clone, element);
        const win = iframe.contentWindow;
        win.addEventListener("afterprint", () => finish());
        await doc.fonts?.ready;
        win.print();
        printed = true;
      } catch (e) {
        finish(e);
      }
    }, { once: true });

    document.body.appendChild(iframe);
  });
